import { Component, input, output, TemplateRef } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatIcon } from "@angular/material/icon";
import { DeleteButtonComponent } from "../../../components/delete-button/delete-button.component";

@Component({
  selector: "vl-header-dialog",
  standalone: true,
  imports: [CommonModule, MatIcon, DeleteButtonComponent],
  templateUrl: "./header-dialog.component.html",
  styleUrl: "./header-dialog.component.scss",
})
export class HeaderDialogComponent {
  title = input<string>();
  close = output();
  canDelete = input<boolean>(false);
  canClose = input<boolean>(true);
  delete = output();
  rightElement = input<TemplateRef<any>>();
  paddingBottom = input<boolean>(true);
}
